import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";
import "./style.scss";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import {
  faCalendar,
  faCheckSquare,
  faCheckCircle,
  faExclamationCircle,
  faTrash,
  faUserCircle,
  faArrowLeft,
  faArrowRight,
  faAngleDown,
  faChartBar,
  faClipboardList,
  faClipboardCheck,
  faPlusSquare,
  faUserCheck,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import Header from "./components/header/Header.js";
import SignIn from "./components/sign-in sign-up/Sign-in";
import SignUp from "./components/sign-in sign-up/Sign-up";
import axios from "axios";
import HomePageUser from "./components/mainSection/homeSection/HomePageUser";
import HomePageCoach from "./components/mainSection/homeSection/HomePageCoach";
import EmployeeList from "./components/mainSection/createChallenge/EmployeeList";
import ChooseSubject from "./components/mainSection/chooseSubjectSection/ChooseSubject";
import ChallengeCreate from "./components/mainSection/createChallenge/Challenge";
import Questions from "./components/mainSection/questionSection/Questions";
import AlertMessage from "./components/actions/Alert";
import UpdateQuestions2 from "./components/mainSection/questionSection/UpdateQuestions2";
import AvailableQuizes from "./components/mainSection/homeSection/AvailableQuizesPerSubject";
import AvailableQuizesCoach from "./components/mainSection/homeSection/AvailableQuizesCoach";
import Dashboard from "./components/mainSection/dashboardSection/Dashboard";
import DashboardMood from "./components/mainSection/dashboardSection/DashboardMood";
import DashboardEmployee from "./components/mainSection/dashboardSection/DashboardEmployee";
import Profile from "./components/mainSection/profileSection.js/Profile";
import DefaultContext from "./contexts/DefaultContext";
import DashboardTop from "./components/mainSection/dashboardSection/DashboardTop";
import DashboardEmployeeMood from "./components/mainSection/dashboardSection/DashboardEmployeeMood";
import DashboardEmployeeMoodAll from "./components/mainSection/dashboardSection/DashboardEmployeeMoodAll";
import DashboardMoodTop from "./components/mainSection/dashboardSection/DashboardMoodTop";
import ReminderSet from "./components/mainSection/createChallenge/ReminderSet";
import FeedbackWebApp from "./components/mainSection/othersSection/FeedbackWebApp";
import UserList from "./components/mainSection/othersSection/UserList";
// Elk icoon van FontAwesome moet voor gebruik geïmporteerd worden en dan in de library hieronder ook gezet worden.
library.add(
  fab,
  faCheckSquare,
  faCheckCircle,
  faExclamationCircle,
  faUserCircle,
  faTrash,
  faCalendar,
  faArrowLeft,
  faArrowRight,
  faAngleDown,
  faChartBar,
  faClipboardList,
  faClipboardCheck,
  faPlusSquare,
  faUserCheck,
  faUser
);
// axios baseURL hangt af van wat de url is van de API, dit is een lokale versie en dus om lokaal te testen.
axios.defaults.baseURL = process.env.REACT_APP_API_ADDR;
function PrivateRoute({ component: Component, ...rest }) {
  const token = sessionStorage.getItem("complexToken");
  return (
    <Route {...rest} render={() => token ? <Component /> : <Redirect to="/Sign-in" />} />
  );
}

// De function App initialiseert meldingen maar ook de routing. Elke nieuwe pagina of wijziging moet dus eerst hier worden gedefinieerd.
function App() {
  const [flashMessages, setFlashMessages] = useState("");
  const [variantFlash, setVariantFlash] = useState("");
  const [alert, setAlert] = useState(false);
  function addFlashMessage(message, variant) {
    setFlashMessages(message);
    setVariantFlash(variant);
  }

  return (
    <div className="App">
      <DefaultContext.Provider
        value={{ setFlashMessages, addFlashMessage, alert, setAlert }}
      >
        <Router>
          <AlertMessage messages={flashMessages} variant={variantFlash} />
          <Header />

          <Switch>
            <Route path="/Sign-in">
              <SignIn />
            </Route>
            <Route path="/" exact>
              <SignIn />
            </Route>
            <Route path="/Sign-up">
              <SignUp />
            </Route>

            <PrivateRoute path="/HomePage" component={HomePageUser} />
            <PrivateRoute path="/ChooseSubject" component={ChooseSubject} />
            <PrivateRoute path="/ChallengeCreate" component={ChallengeCreate} />
            <PrivateRoute path="/Questions" component={Questions} />
            <PrivateRoute path="/DashboardMood" component={DashboardMood} />
            <PrivateRoute path="/UpdateQuestions2" component={UpdateQuestions2} />
            <PrivateRoute path="/Dashboard" component={Dashboard} />
            <PrivateRoute path="/DashboardTop" component={DashboardTop} />
            <PrivateRoute path="/DashboardMoodTop" component={DashboardMoodTop} />
            <PrivateRoute path="/DashboardEmployee" component={DashboardEmployee} />
            <PrivateRoute path="/DashboardEmployeeMood" component={DashboardEmployeeMood} />
            <PrivateRoute path="/DashboardEmployeeMoodAll" component={DashboardEmployeeMoodAll} />
            <PrivateRoute path="/AvailableQuizesPerSubject" component={AvailableQuizes} />
            <PrivateRoute path="/AvailableQuizesCoach" component={AvailableQuizesCoach} />
            <PrivateRoute path="/Profile" component={Profile} />
            <PrivateRoute path="/EmployeeList" component={EmployeeList} />
            <PrivateRoute path="/HomePageCoach" component={HomePageCoach} />
            <PrivateRoute path="/ReminderSet" component={ReminderSet} />
            <PrivateRoute path="/FeedbackWebApp" component={FeedbackWebApp} />
            <PrivateRoute path="/UserList" component={UserList} />

            <Route path="/">
              <SignIn />
            </Route>
          </Switch>
        </Router>
      </DefaultContext.Provider>
    </div>
  );
}

export default App;
